import { Injectable } from '@angular/core';
import {
  CartService,
  Product,
  AuthService,
  ProductService,
  AppState,
  GungGoogleTagManagerService
} from 'gung-standard';
import { Store } from '@ngrx/store';
import { first } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RefCartService extends CartService {
  isRef = environment.projectName === 'ref';

  protected productsList: Product[] = [];

  constructor(
    protected store: Store<AppState>,
    protected authService: AuthService,
    protected productService: ProductService,
    gungGoogleTagManagerService: GungGoogleTagManagerService
  ) {
    super();
    if (this.isRef) {
      const subs = super.getCurrentCart().subscribe(cartContents => {
        if (cartContents.length > 0) {
          subs.unsubscribe();
          const productsIds = cartContents.map(p => p.productId);
          this.productService
            .getProductsByIds(productsIds)
            .pipe(first())
            .subscribe(productsByIds => {
              this.productsList = productsByIds;
            });
        }
      });
    }
  }

  addToCart(productId: string, qty: number, targetStockId?: string): void {
    if (this.isRef) {
      qty = this.preProcessQty(productId, qty);
    }
    super.addToCart(productId, qty, targetStockId);
  }

  subtractFromCart(productId: string, qty: number, targetStockId?: string): void {
    if (this.isRef) {
      qty = this.preProcessQty(productId, qty);
    }
    super.subtractFromCart(productId, qty, targetStockId);
  }

  setProductQuantity(productId: string, qty: number, targetStockId?: string): void {
    if (this.isRef) {
      qty = this.preProcessQty(productId, qty);
    }
    super.setProductQuantity(productId, qty, targetStockId);
  }

  preProcessQty(productId: string, qty: number) {
    const product = this.productsList.find(p => p.id === productId);
    if (!product) {
      this.productService
        .getProduct(productId)
        .pipe(first())
        .subscribe(productByIds => {
          this.productsList.push(productByIds);
        });
    }
    const stepAmount = product && product.extra.ar ? product.extra.ar.artfsgforp : null;

    if (qty !== 0 && stepAmount) {
      if (qty < stepAmount) {
        qty = stepAmount;
      } else {
        const dif = qty % stepAmount;
        if (dif !== 0) {
          qty = qty - dif + stepAmount;
        }
      }
    }
    return qty;
  }
}
